import { redirect } from 'react-router-dom'

const ID_SEGMENT = /^(?:[a-z]{2,5}-[A-Za-z0-9]+|[A-Fa-f0-9]{24,}|[A-Za-z0-9_-]{10,})$/
const DETAIL_SEGMENTS = new Set([
  'permission',
  'detail',
  'member-detail',
  'monitor',
  'settings',
  'usage',
])

function hasAnyId(parts: string[]) {
  return parts.some((p) => ID_SEGMENT.test(p))
}

function computeParentPath(pathname: string): string {
  if (!pathname.startsWith('/team/')) return pathname
  const parts = pathname.split('/').filter(Boolean)
  if (parts.length <= 2) return pathname

  if (!hasAnyId(parts)) {
    // example: /team/snapshots/admin、/team/instances/
    return pathname
  }

  const last = parts[parts.length - 1]
  const prev = parts[parts.length - 2]
  const isLastId = ID_SEGMENT.test(last)
  const isPrevId = ID_SEGMENT.test(prev)
  const isLastDetail = DETAIL_SEGMENTS.has(last)
  const isPrevDetail = DETAIL_SEGMENTS.has(prev)

  let target = pathname

  // .../<detail>/<id> or .../<id>/<detail> → go back two levels to the list
  // example: /team/snapshots/admin/1234567890 -> /team/snapshots/admin
  if ((isLastId && isPrevDetail) || (isLastDetail && isPrevId)) {
    target = '/' + parts.slice(0, -2).join('/')
  }
  // .../<id> or .../<detail> → go back one level
  // example: /team/snapshots/admin/1234567890 -> /team/snapshots/admin
  else if (isLastId || isLastDetail) {
    target = '/' + parts.slice(0, -1).join('/')
  }
  // .../<id>/<something-else>（something is not in the detail list）→ go back two levels
  // example: /team/snapshots/admin/1234567890/something-else -> /team/snapshots/admin
  else if (isPrevId) {
    target = '/' + parts.slice(0, -2).join('/')
  }

  if (target === '/team') return '/team/home'
  return target
}

export function teamSwitchLoader({ request }: { request: Request }) {
  // only when team switching happens for the first time, not when clicking/refreshing
  if (typeof window === 'undefined') return null
  const flag = sessionStorage.getItem('__team_switching__')
  if (!flag) return null

  sessionStorage.removeItem('__team_switching__')

  const url = new URL(request.url)
  const pathname = url.pathname
  if (!pathname.startsWith('/team/')) return null

  const target = computeParentPath(pathname)
  if (target !== pathname) {
    throw redirect(target)
  }
  return null
}
